import React from 'react';

import { SalesOrderIcon } from '../../Assets/Navigation/NavigationIcons';

import Email from '../../Components/Email/Email';
import { t } from 'i18next';

export default (props) => {
  return (
    <Email
      {...props}
      Icon={SalesOrderIcon}
      name={t('saleOrder.sales_order')}
      onCancelURL="/salesorders"
      emailAPI={`salesorders/${props.match.params.id}/mail`}
      fetchDataAPI={`salesorders/${props.match.params.id}/mail`}
      getBackTab
    />
  );
};
